import { Fragment, useState } from "react";
import Header from "../Header/Header";
import RightMenu from "../Header/RightMenu";
import { Drawer } from "@mui/material";
import UserSearchTable from "./Table";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

function UserSearch() {
    const [state, setState] = useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    return (
        <Fragment>
                       <Breadcrumb title={"  لیست جستجوی کاربران  "} />


            <UserSearchTable />
        </Fragment>
    );
}

export default UserSearch;
